// ABOUTME: Derives the configurator's featuresHiddenPrice prop from a resolved product.
// ABOUTME: Returns every feature code when the model opted into hidden prices, else an empty list.

import { ConfiguratorProduct } from '@src/_new/utils/configuratorProduct';

/**
 * The configurator hides a feature's price only when its code is in featuresHiddenPrice. To hide
 * all prices we pass every feature code; when the model did not opt in we pass an empty array.
 */
export const getFeaturesHiddenPrice = (product: ConfiguratorProduct | undefined): string[] =>
    product?.hidePrices
        ? (product.nodes ?? []).flatMap(n => n.features).map(feature => feature.code)
        : [];
